import { fully } from "./fully";

interface Device {
  id: string;
  salt: string;
  device_id: string;
  timezone: string;
}

interface Version {
  marketing: string;
  code: string;
}

interface WifiSetting {
  ip4: string;
  ip6: string;
  mac: string;
}

interface MobileSetting {
  imei: string;
  sim: string;
}

interface Network {
  wifi: WifiSetting;
  mobile: MobileSetting;
}

interface LocalSettings {
  scan_format?: string;
  default_brand?: string;
}

interface Status {
  device: Device;
  localSettings: LocalSettings;
  api: string;
  branding: string;
  version: Version;
  network: Network;
}

const versionCode = import.meta.env.VITE_APP_VERSION_CODE || '-';
const versionMarketing = import.meta.env.VITE_APP_VERSION_MARKETING || '-';

const statusPromise: Promise<Status> = new Promise(resolve => {
  const localSettings: LocalSettings = JSON.parse(localStorage.localSettings || '{}');

  resolve({
    device: JSON.parse(localStorage.deviceConfig || '{}'),
    localSettings: localSettings,
    api: import.meta.env.VITE_APP_BASE_URL || 'no-url-set',
    branding: localSettings['default_brand'] || import.meta.env.VITE_APP_BRANDING || 'red',
    version: {
      marketing: versionMarketing,
      code: versionCode,
    },
    network: {
      wifi: {
        ip4: fully.getIp4Address(),
        ip6: fully.getIp6Address(),
        mac: fully.getMacAddress(),
      },
      mobile: {
        imei: fully.getImei(),
        sim: fully.getSimSerialNumber(),
      }
    },

  })
});

const isTerminal = import.meta.env.VITE_APP_TARGET === 'terminal';

export { Status, statusPromise, versionCode, versionMarketing, isTerminal }
